export const MEETING_RESPONSE_STATUS = {
  WAITTING: 1,
  JOIN: 2,
  REFUSE: 3,
  AGENT: 4,
}